var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeeManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 22,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n      .st0{fill:#ffffff;}\n    "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M360,343.266c-6.5,0-11.75,5.25-11.75,11.734s5.25,11.75,11.75,11.75c6.469,0,11.734-5.266,11.734-11.75 S366.469,343.266,360,343.266z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.531,306.203h-3.781v-55.297c0-14.063-4.75-27-12.672-37.375L512,179.438l-4.172-6.813L402.656,1.172 L180.938,137.141H94c-50.531,0-91.594,39.875-93.797,89.828l-0.016,0.109L0,243.516v35.719v137.594c0,51.922,42.078,93.984,94,94 h318.25c34.109-0.016,61.75-27.656,61.75-61.766v-45.266h1.531c9.672-0.016,17.5-7.828,17.516-17.5v-62.594 C493.031,314.031,485.219,306.203,475.531,306.203z M397.344,23.156l92.688,151l-43.781,26.828 c-4.5-3.281-9.484-5.953-14.797-7.938l12.516-7.672c-4.656-14.594-0.484-30.797,10.906-41.156l-46.688-76.141 c-14.438,5.375-30.719,1.781-41.641-8.984L154.469,189.141h-27.688L397.344,23.156z M393.5,146.625 c-6.906,4.188-15.875,2.016-20.125-4.891c-4.188-6.813-2-15.875,4.813-20.047c6.906-4.266,15.969-2.094,20.125,4.813 C402.563,133.391,400.406,142.391,393.5,146.625z M301.563,153.938l-1.609-0.641c0,0-5.531-0.656-9.625,0.563 c-2.484,0.719-4.984,1.672-7.453,2.875l-4.422-7.141l-10.109,6.188l4.5,7.375c-1.047,0.875-2.094,1.766-2.969,2.734 c-2.094,2.328-3.688,4.813-4.734,7.531c-1.047,2.734-1.438,5.469-1.203,8.344c0.203,2.469,1.078,4.922,2.391,7.375h-31.984 c0.063-20.641,10.359-40.781,29.266-52.375c29.047-17.813,67.078-8.75,84.797,20.297c6.172,10.031,9.063,21.125,9.078,32.078 h-30.188c-0.484-1.203-1-2.391-1.734-3.594c-3.063-5.063-6.906-7.953-11.563-8.672c-4.656-0.797-10.031,0.406-16.297,3.453 l-8.422,4.25c-3.047,1.438-5.453,2.016-7.297,1.688s-3.359-1.453-4.484-3.375c-1.375-2.156-1.609-4.484-0.719-6.813 c0.797-2.406,3.031-4.656,6.484-6.828c2.734-1.672,5.453-2.891,8.344-3.766c2.813-0.875,6.828-0.563,6.828-0.563 c0.875-0.078,1.594-0.719,1.766-1.531l1.844-7.703L301.563,153.938z M457.969,449.063c-0.016,12.641-5.125,24.031-13.406,32.328 c-8.281,8.281-19.656,13.375-32.313,13.391H94c-21.547-0.016-40.984-8.719-55.125-22.828 c-14.125-14.141-22.813-33.578-22.828-55.125V279.234v-35.563l0.203-16.047c1.828-41.406,35.906-74.453,77.75-74.438h60.781 l-58.563,35.953l-23.422,0.016v16.047l337.359-0.016c12.578,0.063,23.906,5.141,32.156,13.391 c8.281,8.297,13.375,19.688,13.391,32.328v55.297H354.344c-13.469-0.016-25.688,5.469-34.5,14.297l-0.016,0.016 c-8.813,8.813-14.281,21.016-14.281,34.484s5.469,25.672,14.266,34.5l0.063,0.031l-0.031-0.016 c8.813,8.813,21.031,14.297,34.5,14.281h103.625V449.063z M477,386.297c0,0.781-0.656,1.453-1.469,1.453H354.344 c-9.125-0.016-17.109-3.609-23.141-9.578h-0.016c-5.969-6.031-9.578-14.047-9.594-23.172c0.016-9.109,3.625-17.141,9.594-23.156 c6.031-5.969,14.031-9.578,23.172-9.594h121.172c0.813,0,1.469,0.672,1.469,1.453V386.297z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.578,
    y: 231.313,
    className: "st0",
    width: 24.078,
    height: 8.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.219,
    y: 231.313,
    className: "st0",
    width: 24.063,
    height: 8.016
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409.531,245.125l4.875-6.359c-6.063-4.672-13.719-7.453-21.969-7.453h-3.063v8.016h3.063 C398.891,239.328,404.781,241.484,409.531,245.125z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.484,227.5l-3.109,7.391c7.625,3.203,16.219,4.438,24.156,4.438h0.953v-8.016h-0.953 C68.438,231.313,60.781,230.156,54.484,227.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.063,
    y: 231.313,
    className: "st0",
    width: 24.063,
    height: 8.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.906,
    y: 231.313,
    className: "st0",
    width: 24.063,
    height: 8.016
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.531,
    y: 270.078,
    className: "st0",
    width: 8.016,
    height: 24.063
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.734,
    y: 231.313,
    className: "st0",
    width: 24.078,
    height: 8.016
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.563,442.203c1.766,6.984,6.203,15.813,13,22.516l5.609-5.734c-5.484-5.297-9.516-13.328-10.828-18.719 L39.563,442.203z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.672,
    y: 465.297,
    className: "st0",
    width: 24.078,
    height: 8.031
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 465.297,
    className: "st0",
    width: 24.063,
    height: 8.031
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M428.547,437.219v-3.5h-8.016v3.5c0,6.313-2.063,12.094-5.563,16.781l6.438,4.797 C425.891,452.797,428.547,445.297,428.547,437.219z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.344,
    y: 465.297,
    className: "st0",
    width: 24.078,
    height: 8.031
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.828,
    y: 465.297,
    className: "st0",
    width: 24.078,
    height: 8.031
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.156,
    y: 465.297,
    className: "st0",
    width: 24.063,
    height: 8.031
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.516,
    y: 465.297,
    className: "st0",
    width: 24.063,
    height: 8.031
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeeManagement);
export default __webpack_public_path__ + "static/media/IconFeeManagement.a57df6441103b564f6d336211f1d2eb0.svg";
export { ForwardRef as ReactComponent };